import React, {useState} from "react";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import {Button, Card, Grid, IconButton, Modal, TextField, Tooltip, Typography} from "@material-ui/core";
import ShareIcon from "@material-ui/icons/ShareOutlined";
import {makeStyles} from "@material-ui/core/styles";
import track from "../util/frontend_analytics";

const useStyles = makeStyles((theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(2),
    },
    iconButton: {
        width: 42,
        height: 42,
        flexShrink: 0,
    },
    customTextField: {
        '& .MuiInputBase-input': {
            cursor: 'pointer',
        },
    },
    card: {
        padding: theme.spacing(3),
        maxWidth: 480,
        width: '100%',
        outline: 'none',
        backgroundColor: '#21161F',
        borderRadius: 20,
    },
    cardText: {
        margin: theme.spacing(1, 0, 2.5),
    },
    copiedTextField: {
        borderColor: theme.palette.success.main,
    },
}));

export default function ShareButton({link, compact = false}: { link?: string, compact?: boolean }) {

    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const [copied, setCopied] = useState(false);

    const copiedToast = () => (
        <Snackbar open={copied} autoHideDuration={6000} onClose={() => setCopied(false)}>
            <Alert onClose={() => setCopied(false)} severity="success">
                Link copied to clipboard!
            </Alert>
        </Snackbar>
    );

    const copyToClipboard = async () => {
        console.log('copying to clipboard')
        console.log(link)
        if (link) {
            await navigator.clipboard.writeText(link);
            setCopied(true);
            track("copy_story_link", {value: 0.05});
        }
    };

    return (
        <>
            {compact ?
                <Tooltip title="Share">
                    <IconButton
                        aria-label="Share"
                        className={classes.iconButton}
                        onClick={() => {
                            setOpen(true);
                        }}
                    >
                        <ShareIcon fontSize="small"/>
                    </IconButton>
                </Tooltip> :
                <Button
                    startIcon={<ShareIcon/>}
                    onClick={() => {
                        setOpen(true);
                    }}
                >
                    Share
                </Button>}
            <Modal open={open} onClose={() => setOpen(false)} className={classes.modal}>
                <Card className={classes.card} elevation={10}>
                    <Typography variant="h5" component="h2">Share your story</Typography>
                    <Typography variant="body2" color="textSecondary" className={classes.cardText}>
                        Only people with this link can access your story. Do not share it if you'd rather keep it
                        private.
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                className={classes.customTextField}
                                fullWidth
                                multiline
                                value={link}
                                InputProps={{
                                    readOnly: true,
                                }}
                                onClick={copyToClipboard}
                                variant="outlined"
                                helperText="Tap the link to copy it."
                            />
                        </Grid>
                    </Grid>
                </Card>
            </Modal>
            {copiedToast()}
        </>
    );
}